export class DebugLogger {
  name: string;
  private enabled: boolean;

  constructor(name?: string) {
    this.name = name ?? "Debug";
    this.enabled = true;
  }

  mute() {
    this.enabled = false;
  }

  unmute() {
    this.enabled = true;
  }

  log(...args: unknown[]) {
    this.displayTextInConsole(console.log, ...args);
  }

  warn(...args: unknown[]) {
    this.displayTextInConsole(console.warn, ...args);
  }

  error(...args: unknown[]) {
    this.displayTextInConsole(console.error, ...args);
  }

  private displayTextInConsole(
    func: (...args: unknown[]) => void,
    ...args: unknown[]
  ) {
    if (this.enabled) {
      const isDebugMode =
        import.meta.env.DEV || globalThis.location.host.startsWith("dev");
      if (isDebugMode) func(`[${this.name}]`, ...args);
    }
  }
}
